<template>
  <div
    class="editor-mode-toggle-buttons"
    style="position:fixed; bottom: 10px; right: 11px; z-index: 100;"
    v-if="isLoggedIn && drawer.type != 'media-manager'"
  >
    <v-btn
      style="border-radius: 4px 0 0 4px"
      small
      dark
      depressed
      :color="currentUser.mode == 'editor' ? 'secondary' : 'primary'"
      @click="confirmModeChange('editor')"
      >Editor</v-btn
    >
    <v-btn
      style="border-radius: 0 4px 4px 0"
      small
      dark
      depressed
      :color="currentUser.mode == 'preview' ? 'secondary' : 'primary'"
      @click="confirmModeChange('preview')"
      >Preview</v-btn
    >

    <!-- TODO - enable inline editing
    <v-btn
      small
      dark
      depressed
      :color="currentUser.mode == 'inline' ? 'secondary' : 'primary'"
      @click="confirmModeChange('inline')"
      style="border-radius: 0 4px 4px 0"
    >Inline</v-btn>-->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { setEditorMode } from '@/graphql/user.gql'
import swal from 'sweetalert2'

export default {
  name: 'EditorModeToggle',
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapState('editor', ['drawer'])
  },
  methods: {
    ...mapActions('editor', ['closeEditor']),
    confirmModeChange(mode) {
      if (this.drawer.changed) {
        swal({
          title: 'Are you sure?',
          text: 'You have unsaved changes that will be lost.',
          type: 'warning',
          confirmButtonText: 'Discard changes',
          cancelButtonText: 'Go back to editing',
          showCancelButton: true,
          allowOutsideClick: false
        }).then(({ value }) => {
          if (value) {
            this.drawer.changed = false
            this.closeEditor()
            this.currentUser.mode = mode
            this.setEditorMode(mode)
          }
        })
      } else {
        this.closeEditor()
        this.currentUser.mode = mode
        this.setEditorMode(mode)
      }
    },
    setEditorMode(mode) {
      if (this.isLoggedIn) {
        this.loading = true

        this.$apollo
          .mutate({
            mutation: setEditorMode,
            variables: {
              mode
            }
          })
          .then(({ data }) => {
            this.loading = false
            this.$apolloProvider.defaultClient.resetStore()

            // set back to large screen mode
            this.$store.commit('editor/SET_SCREEN_MODE', 'lg')
          })
          .catch(error => {
            this.handleGraphQLErrors(error)

            this.loading = false
          })
      }
    }
  }
}
</script>

<style>
.editor-mode-toggle-buttons
  .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
  opacity: 1;
}
.editor-mode-toggle-buttons.v-btn-toggle:not(.v-btn-toggle--group)
  .v-btn.v-btn.v-item--active
  span {
  color: #ffffff !important;
}
</style>
